import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { useIntl } from 'react-intl';
import Button from 'shared/ui/Button';
import { Edit } from '../../styled';
import ModalWarning from 'Common/Components/ModalWarning';
import { getVulnId } from 'Common/Functions/vulnerabilityId';

const EditButton = ({
  hasVulns,
  vulnsSelected,
  openVulnDetail,
  isExploreAssetsTab,
  isExploreServicesTab,
  selectedHostIds,
  selectedServiceIds,
  openHostDetail,
  openServiceDetail
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.UPDATE));
  const intl = useIntl();

  const handleClick = () => {
    if (!canUpdate) return;

    if (isExploreAssetsTab) {
      if (selectedHostIds.length === 1) openHostDetail(selectedHostIds[0]);
      else setShowWarning(true);
      return;
    }

    if (isExploreServicesTab) {
      if (selectedServiceIds.length === 1) openServiceDetail(selectedServiceIds[0]);
      else setShowWarning(true);
      return;
    }

    if (hasVulns) {
      if (vulnsSelected.length === 1) openVulnDetail(getVulnId(vulnsSelected[0]));
      else setShowWarning(true);
    }
  };

  const getWarningMessage = () => {
    if (isExploreAssetsTab) return intl.formatMessage({ id: 'modalWarning.selectOnlyOne' }, { entity: 'asset' });
    if (isExploreServicesTab) return intl.formatMessage({ id: 'modalWarning.selectOnlyOne' }, { entity: 'service' });
    return intl.formatMessage({ id: 'modalWarning.selectOnlyOne' }, { entity: 'vulnerability' });
  };

  const isDisabled = () => {
    if (!canUpdate) return true;
    if (isExploreAssetsTab) return selectedHostIds.length === 0;
    if (isExploreServicesTab) return selectedServiceIds.length === 0;
    return !hasVulns;
  };

  const onClose = () => setShowWarning(false);

  return (
    <>
      <Button variant="ghost" startIcon={ <Edit /> } title="Edit" ariaLabel="Edit" onClick={ handleClick } disabled={ isDisabled() } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Edit" description={ getWarningMessage() } /> }
    </>
  );
};

export default EditButton;
